import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';
import { LocationWarningComponent } from './location-warning.component';
import { ServicesSharedModule } from 'src/app/services/services-shared.module';


@NgModule({
  declarations: [
    LocationWarningComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule,
    ServicesSharedModule
  ]
})
export class LocationWarningModule {}